import React, { memo } from 'react';
import { Text, StyleSheet, Pressable } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import { PlusView, MinusView } from './plus_view';
import DivWebOnly from '../div_web_only';

export default memo(function (props) {
  const { label, onPress, disabled, containerStyle, labelStyle, minusMode } = props;
  const ViewComponent = minusMode ? MinusView : PlusView;
  return (
    <DivWebOnly className="op-main-btn-hover-container">
      <Pressable
        style={[styles.headerButton, containerStyle]}
        onPress={onPress}
        disabled={!!disabled}
        testID="addButton"
      >
        <Text style={[styles.headerLabel, labelStyle]}>{label}</Text>
        {!disabled && (
          <DivWebOnly className="op-main-btn">
            <ViewComponent style={{ width: 25, height: 25, borderRadius: 3 }} />
          </DivWebOnly>
        )}
      </Pressable>
    </DivWebOnly>
  );
});

const styles = StyleSheet.create({
  headerButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLabel: {
    ...FONT.regular,
    fontSize: 16,
    color: 'rgb(108, 108, 108)',
    marginRight: 10,
  },
});
